import { render, staticRenderFns } from "./ExemptionList.vue?vue&type=template&id=c01fe76c&"
import script from "./ExemptionList.vue?vue&type=script&lang=js&"
export * from "./ExemptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports